import pick from 'lodash-es/pick';
import { createSlice, PayloadActionCreator } from '@reduxjs/toolkit';

import { defaultState as commonConfigDefaultState } from 'common/reducers/config';
import { resetStoresAction } from 'common/actions/common';
import {
  configFetchAction,
  configFetchSuccessAction,
  configUpdateAction,
} from 'common/actions/config';
import { AffiliatesConfigState } from 'common/types';

const defaultState: AffiliatesConfigState = {
  ...commonConfigDefaultState,
  isFetching: false,
  accountManager: null,
  modelTiers: {},
  sidebarWarning: {
    paymentDetails: false,
  },
  tiers: {},
  firstVisitFrom: '',
  postbackAvailableParameters: [],
  whiteLabelDomains: [],
  wasCookiesPolicyAccepted: false,
  language: null,
  whiteLabels: { baseDomain: '' },
};

const keepConfigKeys = [
  'env',
  'version',
  'features',
  'url',
  'firstVisitFrom',
  'referral',
  'wasCookiesPolicyAccepted',
  'countries',
];

const config = createSlice({
  initialState: defaultState,
  name: 'config',
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(
        configFetchAction,
        (state: AffiliatesConfigState): AffiliatesConfigState => ({
          ...state,
          isFetching: true,
        }),
      )
      .addCase(
        configUpdateAction as PayloadActionCreator<
          Partial<AffiliatesConfigState>
        >,
        (state: AffiliatesConfigState, { payload }): AffiliatesConfigState => ({
          ...state,
          ...payload,
        }),
      )
      .addCase(
        configFetchSuccessAction as PayloadActionCreator<AffiliatesConfigState>,
        (state: AffiliatesConfigState, { payload }): AffiliatesConfigState => ({
          ...state,
          ...payload,
          isFetching: false,
        }),
      )
      .addCase(
        resetStoresAction,
        (state: AffiliatesConfigState): AffiliatesConfigState => ({
          ...defaultState,
          ...pick(state, keepConfigKeys),
        }),
      ),
});

export default config.reducer;
